import { Document, ILinkItem } from '@belong/types';
import { withBasePath } from '@belong/url-utils';
import { ISupportCategory } from '@belong/types/support';
import { ISupportArticleTemplate } from './templates';

export interface ISectionSupportArticle {
  id?: string;
  content: Document;
  template: ISupportArticleTemplate;
  relatedArticles: ILinkItem[];
}

const FSectionSupportArticle = (data: any): ISectionSupportArticle => {
  const { category, article } = data;
  const { id, content, template } = article;

  const relatedArticles: ILinkItem[] = data.relatedArticles.map(({ title, metaPageSlug }) => {
    const { path = '' } = category as ISupportCategory;
    return { label: title, href: withBasePath(`${path}/${metaPageSlug}`) };
  });

  return {
    id,
    content,
    template,
    relatedArticles
  };
};

export default FSectionSupportArticle;
